import type { StreamDeltaPayload } from './templateStreamEnvelope';

/**
 * @deprecated Use `StreamDeltaPayload` from templateStreamEnvelope.ts
 */
export type StreamType = StreamDeltaPayload;

export enum StreamStatus {
  'IDLE' = 'IDLE',
  'WAITING_START' = 'WAITING_START',
  'STREAMING' = 'STREAMING',
  'ERROR' = 'ERROR',
}

export type AnimationType = 'chat' | 'edit' | 'oldTemplate';

export type StreamState = {
  status: StreamStatus;
  abortController: AbortController;
  animationType?: AnimationType;
};
